
  <div class="row card-deck">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">
      <!--<div class="modal-header">
    <h4 class="modal-title">Change Password</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>-->
      <div class="card-header wh-header">
        Change Password
        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- Form actions layout section start -->

        <div class="card change-password">

          <div class="card-body">
            <div class="card-block">
              <!--<div class="text-center">
            <h4 class="text-uppercase text-bold-400 white">Change Password</h4>
          </div>-->
              <form class="pt-4" (ngSubmit)="onChangePassword()" #f="ngForm">
                <div class="form-group">
                  <input type="password" class="form-control" name="CurrentChangePasswordRequest.NewPassword"
                         id="CurrentChangePasswordRequest.NewPassword" required placeholder="Enter NewPassword" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                         [(ngModel)]="CurrentChangePasswordRequest.NewPassword" #NewPassword="ngModel" minlength="4">
                  <small class="form-text text-danger"
                         *ngIf="(!NewPassword.valid && (NewPassword.dirty || NewPassword.touched) && NewPassword.errors.minlength && !isRequesting)">(Mininum 4 Chars)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!NewPassword.valid && NewPassword.errors.pattern && !NewPassword.errors.minlength && !isRequesting) ">(special characters are not allowed)</small>

                </div>
                <div class="form-group">
                  <input type="password" class="form-control" name="CurrentChangePasswordRequest.ReEnterPassword"
                         id="CurrentChangePasswordRequest.ReEnterPassword" required placeholder="Enter ReEnterPassword" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                         [(ngModel)]="CurrentChangePasswordRequest.ReEnterPassword" #ReEnterPassword="ngModel" minlength="4">
                  <small class="form-text text-danger"
                         *ngIf="(!ReEnterPassword.valid && (ReEnterPassword.dirty || ReEnterPassword.touched) && ReEnterPassword.errors.minlength && !isRequesting)">(Mininum 4 Chars)</small>
                  <small class="form-text text-danger"
                         *ngIf="(!ReEnterPassword.valid && ReEnterPassword.errors.pattern && !ReEnterPassword.errors.minlength && !isRequesting) ">(special characters are not allowed)</small>

                </div>
                <div>


                </div>
                <div class="modal-footer">
                  <button type="submit" [disabled]="!f.valid" class="btn btn-primary modal-button-center change-button" *ngIf='!isRequesting'>Change Password</button>
                </div>
              </form>
            </div>

          </div>
        </div>

        <!-- // Form actions layout section end -->
      </div>


      <!--<div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
  </div>-->
    </div>
  </div>
